import { combineEpics } from "redux-observable";
import authEpics from "./auth/epics";
import UserEpics from "./User/epics";
import userprofileEpics from "./userprofile/epics";

const epics = [...authEpics, ...UserEpics, ...userprofileEpics];
const rootEpic = combineEpics(...epics);
export default rootEpic;
